import { Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { WorldMap } from '@/components/world-map'

const AdminPanel = import.meta.env.DEV
  ? lazy(() => import('@/components/admin/admin-panel'))
  : null

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <main className="h-[100dvh] w-full">
            <Suspense fallback={
              <div className="flex items-center justify-center h-[100dvh]">
                <div className="text-lg">Loading map...</div>
              </div>
            }>
              <WorldMap className="h-full w-full" />
            </Suspense>
          </main>
        } />
        {AdminPanel && (
          <Route path="/admin" element={
            <Suspense fallback={
              <div className="flex items-center justify-center h-[100dvh]">
                <div className="text-lg">Loading admin panel...</div>
              </div>
            }>
              <AdminPanel />
            </Suspense>
          } />
        )}
      </Routes>
    </BrowserRouter>
  )
}
